// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"ViewBoardCategory_modal-scroll__2TPhY","article-category":"ViewBoardCategory_article-category__5H2dY"};